import api from '../request'
import { USER_PROFILE_ENDPOINTS } from '../../const/EndPoints'
import { User } from '../../models/User'

interface UpdateProfilePictureResponse {
  message: string
  url: string
  updatedAt: Date
}

interface DeleteProfilePictureResponse {
  message?: string
}

// get user profile
export const getProfile = async (): Promise<User> => {
  const response = await api.get<User>(
    USER_PROFILE_ENDPOINTS.GET_PROFILE
  )
  return response.data
}

// create user profile
export const createProfile = async (payload: User): Promise<User> => {
  const response = await api.post<User>(
    USER_PROFILE_ENDPOINTS.SAVE_PROFILE,
    payload
  )
  return response.data
}

// update user profile
export const updateProfile = async (
  payload: Partial<User>
): Promise<User> => {
  const response = await api.put<User>(
    USER_PROFILE_ENDPOINTS.UPDATE_PROFILE,
    payload
  )
  return response.data
}

// update user profile picture
export const updateProfilePicture = async (
  payload: FormData
): Promise<UpdateProfilePictureResponse> => {
  const response = await api.put<UpdateProfilePictureResponse>(
    USER_PROFILE_ENDPOINTS.UPDATE_PROFILE_PICTURE,
    payload
  )
  return response.data
}

// delete user profile picture
export const deleteProfilePicture = async (): Promise<DeleteProfilePictureResponse> => {
  const response = await api.delete<DeleteProfilePictureResponse>(
    USER_PROFILE_ENDPOINTS.DELETE_PROFILE_PICTURE
  )
  return response.data
}

interface DeleteAllDataResponse {
  data: {
    message: string
  }
  error: null
}

// delete all user data across all services (GDPR Article 17)
export const deleteAllUserData = async (): Promise<DeleteAllDataResponse> => {
  const response = await api.delete<DeleteAllDataResponse>(
    USER_PROFILE_ENDPOINTS.DELETE_ALL_DATA
  )
  return response.data
}

export interface MedicalProfile {
  medications: string[]
  allergies: string[]
  conditions: string[]
  familyHistory: { condition: string; relation: string }[]
}

export const getMedicalProfile = async (): Promise<MedicalProfile> => {
  const response = await api.get<MedicalProfile>(
    USER_PROFILE_ENDPOINTS.MEDICAL_PROFILE
  )
  return response.data
}

export const saveMedicalProfile = async (
  profile: MedicalProfile
): Promise<MedicalProfile> => {
  const response = await api.put<MedicalProfile>(
    USER_PROFILE_ENDPOINTS.MEDICAL_PROFILE,
    profile
  )
  return response.data
}
